module.exports = __webpack_public_path__ + "static/mat1620_compilado-20a5175a89fc85bd57e3451432303247.pdf";